$(document).ready(
    function _readyStoreDetails() {

        $(".setMyStoreButton").click(onClickSetMyStore);

        $('#get-directions-button').on('click', function () {
            pushDataLayerStoreDetailsGetDirections();
        });

        var el = document.createElement('script');
        el.type = 'application/ld+json';
        el.text = storeJsonLd;
        document.querySelector('head').appendChild(el);

    });
